var render = function render(_c,_vm){return _c(_vm.props.component,_vm._b({tag:"component",on:{"close":_vm.props.close}},'component',_vm.props.userdata,false))
}
var staticRenderFns = []

export { render, staticRenderFns }